import axios from 'axios'

const dealComponents = (teamCode, components = []) => components.reduce((all, item) => {
    const { namespace } = item.packageMeta.meta
    // 自定义组件且没有 namespace 时，自动注入为当前应用的 teamCode，由于 emulator 与 render-engine 加载组件逻辑不一致，需将 name 带上 teamCode（emulator 用 name 加载的，render-engine 用 namespace、packageName、componentName 拼的）
    if (!item.isSystem && !namespace && teamCode) {
        item.packageMeta.meta.namespace = teamCode
        item.name = `${teamCode}-${item.name}`
    }
    return [...all, item]
}, [])

export function getDevComponents({
    devComponentHost,
    devComponentPort,
    teamCode,
}) {
    // 开发服务有可能是 http & https 无法识别
    return new Promise((resolve, reject) => {
        window._DEV_PROTOCOL = 'http'
        const { _DEV_PROTOCOL: protocol } = window
        const result = axios.get(`${protocol}://${devComponentHost}:${devComponentPort}/manifest.json`)
        
        result
            .then(res => resolve({
                ...res,
                data: dealComponents(teamCode, res.data),
            }))
            .catch(err => {
                if (err && err.message === 'Network Error') {
                    window._DEV_PROTOCOL = 'https'
                    const httpResult = axios.get(`https://${devComponentHost}:${devComponentPort}/manifest.json`)
                    httpResult
                        .then(res => resolve({
                            ...res,
                            data: dealComponents(teamCode, res.data),
                        }))
                        .catch(() => reject())
                } else {
                    reject()
                }
            })
    })
}
